import { CherryPayApi } from "../../api/models";
import { isEmptyStr } from "../../util/StringUtil";
import { Box, Flex, Link } from "@chakra-ui/react";
import { Tag, TagLabel, TagLeftIcon, TagRightIcon } from "@chakra-ui/tag";
import DateUtil from "../../util/DateUtil";
import React from "react";
import { CheckIcon, ChevronRightIcon, DeleteIcon } from "../../styles/icons";

interface SubmissionFinalisationColumnProps {
  item: CherryPayApi.MembershipRequestSummaryItem;
}

const FinaliseMembershipLink = ({ url }: { url: string }) => (
  <Link
    href={url}
    target="_blank"
    display="inline-flex"
    alignItems="center"
    gap={1}
    px={2.5}
    py={1}
    borderRadius="full"
    fontSize="sm"
    fontWeight="medium"
    color="cherryButton.500"
    backgroundColor="cherryPink.100"
    border="1px solid"
    borderColor="transparent"
    textDecoration="none"
    whiteSpace="nowrap"
    _hover={{
      textDecoration: "none",
      backgroundColor: "cherryButton.25",
      color: "cherryButton.600",
      borderColor: "cherryButton.800",
      boxShadow: "md",
    }}
  >
    Finalise Membership
    <ChevronRightIcon boxSize={3.5} />
  </Link>
);

export const SubmissionFinalisationColumn = ({
  item,
}: SubmissionFinalisationColumnProps) => {
  const finalisation = item.SubmissionFinalisation;
  const finalisationIsNotPresent = !finalisation;
  const requestUrlIsPresent = !isEmptyStr(item.MembershipRequestUrl);
  const notCompletedYet =
    item.NextStep !== "User Completed" && item.NextStep !== "Completed";

  if (finalisationIsNotPresent || !requestUrlIsPresent || notCompletedYet) {
    return <>-</>;
  }

  if (item.NextStep === "User Completed") {
    return <FinaliseMembershipLink url={item.MembershipRequestUrl!} />;
  }

  const accepted = finalisation!.SubmissionAccepted;
  const StatusIcon = accepted ? CheckIcon : DeleteIcon;
  const statusIconColor = accepted
    ? "riskRating.safe.icon"
    : "riskRating.highRisk.icon";
  const statusLabel = accepted ? "Accepted" : "Rejected";

  return (
    <Flex alignItems="flex-start" flexDirection="column">
      <Tag
        as={Link}
        href={item.MembershipRequestUrl!}
        target="_blank"
        mb={1}
        borderRadius="full"
        bg="membershipRequestStatus.incomplete.bg"
        border="1px solid"
        borderColor="transparent"
        cursor="pointer"
        textDecoration="none"
        _hover={{
          textDecoration: "none",
          bg: "gray.100",
          borderColor: "cherryBorder.800",
          boxShadow: "md",
        }}
      >
        <TagLeftIcon
          as={StatusIcon}
          bg={statusIconColor}
          color="white"
          borderRadius="full"
          boxSize={4}
          p="2px"
          mr={2}
        />
        <TagLabel>{statusLabel}</TagLabel>
        <TagRightIcon as={ChevronRightIcon} boxSize={3.5} />
      </Tag>
      <Box as="span" ml={2}>
        {DateUtil.getLocalDateFormatFromString(finalisation!.FinalisedDate)}
      </Box>
    </Flex>
  );
};
